import 'babel-polyfill'
import objectFitImages from 'object-fit-images'
import '@fancyapps/fancybox'
import {without, throttle, debounce} from 'lodash'
import 'reframe.js/dist/jquery.reframe.min'
import whatInput from 'what-input'
import 'jquery-match-height/jquery.matchHeight'

import './ad-tracking'
import './content'
import './selects'
import './front-page'
import './header'
import './load-more'
import './news'
import './partners'
import './popup'
import './scores'

objectFitImages()

jQuery.fancybox.defaults.animationEffect = 'fade'
jQuery.fancybox.defaults.gash = false
jQuery.fancybox.defaults.buttons = [
    'close'
]

jQuery('.content iframe').reframe()

if (jQuery('.intro').hasClass('intro--with-image')) {

} else {
    if (jQuery('body').hasClass('home') || jQuery('body').hasClass('page-template-tournament')) {

    } else {
        jQuery('.header').addClass('header--white-bg')
    }

    jQuery('.top-page-decoration').css({
        height: jQuery('.intro').outerHeight() + 80
    })

    jQuery('.top-page-decoration--mobile').css({
        height: jQuery('.intro').outerHeight()
    })

    jQuery('.top-page-decoration--medium').css({
        height: jQuery('.intro').outerHeight()
    })
}

jQuery(document).ready(function () {
    let newsSidebar = jQuery('.news__sidebar')

    if (window.matchMedia("(min-width: 1024px)").matches) {
        newsSidebar.appendTo('.news__wrapper')
    } else {
        newsSidebar.prependTo('.news__aside')
    }

    //console.log('READY');

    jQuery('.news-search #dsi').focus( function() {
      jQuery('.news-search').addClass('news-search--active');
    });

    jQuery('.news-search #dsi').blur( function() {
      jQuery('.news-search').removeClass('news-search--active');
    });

    jQuery('.block__info, .tickets__subcaption, .food__content, .hotel__content').matchHeight( { byRow: true } );

    jQuery('.hotel__rates, .tickets .caption').matchHeight( { byRow: true } );

    jQuery('.tickets__content').matchHeight( { byRow: true } );

    jQuery('.hotel__icon-strip__tooltip').each( function ( index ) {
        let tooltip_width;

        if ( jQuery( this ).outerWidth() > 85 )
            tooltip_width = -( jQuery( this ).outerWidth() / 2 ) + 22;
        else
            tooltip_width = -( jQuery( this ).outerWidth() / 2 ) + 18;

        jQuery( this ).css( 'margin-left', tooltip_width );
    });

    if ( jQuery('.tournament__events__item').length % 3 == 0 ) {
        jQuery('.tournament__events').addClass( 'hide-after' );

        jQuery('.tournament__events__item').eq(-1).css( 'margin-left', '0' );
    }

})
